/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-throw-literal */
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OrderTracker from '../../shared/blocks/order-tracker/order-tracker';
import useIsDesktop from '../../../utilities/hooks/useIsDesktop';
import OrderImage from '../../../utilities/components/OrderImage';
import { calculateOrderTotalDiscount, convertCentsToDollars } from '../../../utilities/utils';

import './orders.scss';
import GlobalError from '../../shared/blocks/global-error/global-error';
import Loader from '../../shared/blocks/loader/loader';
import useOrdersHistory from '../../../utilities/hooks/useOrdersHistory';

const TRACK_BTN = 'track-btn';

const showProducts = (order) => {
  let result = [];
  const products = order.lineItems;
  if (products.length > 3) {
    for (let i = 0; i < 3; i++) {
      result.push(products[i]);
    }
  } else if (products.length > 0) {
    result = products;
  } else {
    result = null;
  }
  return result;
};

const moreProducts = (products, isDesktop) => {
  let result = null;
  const numberToShow = isDesktop ? 3 : 1;
  if (products.length > 0 && products.length > numberToShow) {
    result = products.length - numberToShow;
  }
  return result;
};

const Orders = () => {
  const isDesktop = useIsDesktop();
  const { isLoading: isLoadingOrders, error } = useOrdersHistory();
  const orders = useSelector((state) => state.accounts.user.orders?.filter(
    (order) => order?.lineItems.length > 0,
  ));

  return (
    <div className="order-page page-view">
      <h3 className="order-page-title c-purple fw-medium ff-wallop m-b-32">
        Order History
      </h3>
      <GlobalError />
      {isLoadingOrders ? (
        <Loader />
      ) : error ? (
        <ErrorTemplate />
      ) : orders?.length > 0 ? (
        <HasOrdersTemplate orders={orders} isDesktop={isDesktop} />
      ) : (
        <NoOrdersTemplate />
      )}
    </div>
  );
};

export default Orders;

const NoOrdersTemplate = () => (
  <div>
    <p className="no-orders-box full-border bg-white m-b-xs fs-p1 c-light-midnight ff-graphik-medium fw-normal">
      There are currently no orders associated with your account.
    </p>
    <a className="w-100" href="https://purple.com">
      <button className="c-white button ta-center w-100" type="button">
        Shop Now
      </button>
    </a>
  </div>
);

const ErrorTemplate = () => (
  <div>
    <p className="no-orders-box full-border bg-white m-b-xs fs-p1 c-light-midnight ff-graphik-medium fw-normal">
      Failed to fetch orders. Try sign out and sign in again.
    </p>
  </div>
);

const HasOrdersTemplate = (props) => {
  const { isDesktop, orders } = props;
  const navigate = useNavigate();

  const navigateToOrder = (e, orderNumber) => {
    e.preventDefault();
    if (e.target.getAttribute('data-id') !== TRACK_BTN) {
      navigate(`/orders/view-order/?order=${orderNumber}`);
    }
  };

  const orderStatus = (status) => {
    let newOrderStatus = '';
    if (status === 'Delivered') {
      newOrderStatus = 'Complete';
    } else if (status === 'Shipped') {
      newOrderStatus = 'Shipped';
    } else {
      newOrderStatus = 'In Progress';
    }
    return newOrderStatus;
  };

  const calculateWhenOrderIsComplete = (dateOfOrder, statusOfOrder) => {
    if (statusOfOrder !== 'Delivered') {
      return orderStatus(statusOfOrder);
    }

    const today = new Date();
    const calculatedMilliseconds = today.getTime() - dateOfOrder.getTime();
    const calculatedDays = Math.floor(calculatedMilliseconds / (86400 * 1000));

    if (statusOfOrder === 'Delivered' && calculatedDays > 30) {
      return 'Complete';
    }

    return statusOfOrder;
  };

  return (
    <div className="orders-view-wrap">
      {orders.length > 0 &&
        orders
          .filter((order) => order?.lineItems.length > 0)
          .map((order, index) => {
            const createdAt = new Date(order.createdAt);
            const orderDate = new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
            }).format(createdAt);
            const orderTotalDiscount = calculateOrderTotalDiscount(order.lineItems);
            return (
              <button
                type="button"
                key={index}
                className="orders-view-order"
                onClick={(e) => navigateToOrder(e, order.orderNumber)}
              >
                <div className="order-view-order-top">
                  <div className="orders-view-order-info">
                    <div className="orders-view-order-number">
                      <p className="order-view-item c-purple ff-graphik fw-normal fs-14">
                        Order
                        {isDesktop && ' number'}
                      </p>
                      <p
                        className="order-view-item c-purple ff-graphik fw-medium fs-18"
                        data-testid={order.orderNumber}
                      >
                        <span>#</span>
                        <span>{order.orderNumber}</span>
                      </p>
                    </div>
                    <div className="orders-view-order-sub-info">
                      <div className="order-view-order-date">
                        <p className="order-view-item c-purple ff-graphik fw-normal fs-14">
                          Order date
                        </p>
                        <p className="order-view-item c-purple ff-graphik fw-medium fs-14">
                          {orderDate}
                        </p>
                      </div>
                      {!isDesktop && (
                        <div>
                          <p className="order-view-item c-purple ff-graphik fw-normal fs-14">
                            Status
                          </p>
                          <p className="order-view-item c-purple ff-graphik fw-medium fs-14">
                            {order.orderState === 'Cancelled' ? order.orderState : calculateWhenOrderIsComplete(createdAt, order.shipmentState)}
                          </p>
                        </div>
                      )}
                      <div>
                        <p className="order-view-item c-purple ff-graphik fw-normal fs-14">
                          Order total
                        </p>
                        <div
                          className="order-amount"
                          data-testid="order-amount"
                        >
                          {orderTotalDiscount > 0 && (
                            <span className="order-amount-original">
                              $
                              {
                                convertCentsToDollars(
                                  order.taxedPrice.totalGross.centAmount,
                                )
                              }
                            </span>
                          )}
                          <span
                            className={
                              orderTotalDiscount > 0
                                ? 'order-amount-with-discount'
                                : ''
                            }
                          >
                            {
                              `$${convertCentsToDollars(
                                order.taxedPrice.totalGross.centAmount - orderTotalDiscount,
                              )}`
                            }
                          </span>
                        </div>
                      </div>
                      {isDesktop && (
                        <div className={`
                          order-view-item-status
                          ${(order.orderState !== 'Cancelled' && orderStatus(order.shipmentState) === 'In Progress') && 'order-view-item-status-in-progress'}
                          ${(order.orderState !== 'Cancelled' && orderStatus(order.shipmentState) === 'Shipped') && 'order-view-item-status-shipped'}
                          ${(order.orderState !== 'Cancelled' && orderStatus(order.shipmentState) === 'Complete') && 'order-view-item-status-complete'}
                          ${order.orderState === 'Cancelled' && 'order-view-item-status-cancelled'}
                        `}
                        >
                          {order.orderState === 'Cancelled' ? order.orderState : calculateWhenOrderIsComplete(createdAt, order.shipmentState)}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="order-view-order-buttons">
                    <div className="orders-view-order-tracker">
                      <OrderTracker orderNum={order.orderNumber} buttonWhite />
                    </div>
                    <div className="orders-view-order-details">
                      <Link
                        to={`/orders/view-order/?order=${order.orderNumber}`}
                        data-testid={`link-to-${order.orderNumber}`}
                      >
                        <button className="button white" type="button">
                          Order Details
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="d-flex product-container">
                  {showProducts(order).map((product, pIndex) => (
                    <div
                      key={pIndex}
                      className="order-view-order-img m-r-8 d-flex"
                    >
                      {product.variant.images[0].url.length > 0 && (
                        <OrderImage
                          imgUrl={product.variant.images[0].url}
                          alt={product.name['en-US']}
                        />
                      )}
                    </div>
                  ))}
                  <div className="d-flex align-items-center order-view-order-img no-bg">
                    {moreProducts(order.lineItems, isDesktop) && (
                      <p className="more-products ff-graphik c-purple-primary fs-p3 fw-normal">
                        <span>+ </span>
                        <span>{moreProducts(order.lineItems, isDesktop)}</span>
                        <span>items</span>
                      </p>
                    )}
                  </div>
                </div>
              </button>
            );
          })}
    </div>
  );
};
